import { Box, Button } from "@mui/material";
import React from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const ButtonView = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2} padding={2}>
      {" "}
      <Box display="flex" gap={1}>
        <Button variant="contained" color="primary">
          Xuất PDF
        </Button>
        <Button variant="contained" color="success">
          Xuất PDF
        </Button>
        <Button variant="contained" color="error">
          Xuất PDF
        </Button>
        <Button variant="contained" color="warning">
          Xuất PDF
        </Button>
        <Button variant="contained" color="primary" disabled>
          Xuất PDF
        </Button>
      </Box>
      <Box display="flex" gap={1}>
        <Button variant="text" color="primary">
          Xuất PDF
        </Button>
        <Button variant="text" color="success">
          Xuất PDF
        </Button>
        <Button variant="text" color="error">
          Xuất PDF
        </Button>
        <Button variant="text" color="warning">
          Xuất PDF
        </Button>
        <Button variant="text" color="primary" disabled>
          Xuất PDF
        </Button>
      </Box>
      <Box display="flex" gap={1}>
        <Button variant="blur" color="primary">
          Xuất PDF
        </Button>
        <Button variant="blur" color="success">
          Xuất PDF
        </Button>
        <Button variant="blur" color="error">
          Xuất PDF
        </Button>
        <Button variant="blur" color="warning">
          Xuất PDF
        </Button>
        <Button variant="blur" color="primary" disabled>
          Xuất PDF
        </Button>
      </Box>
      <Box display="flex" gap={1}>
        <Button variant="outlined" color="primary">
          Xuất PDF
        </Button>
        <Button variant="outlined" color="success">
          Xuất PDF
        </Button>
        <Button variant="outlined" color="error">
          Xuất PDF
        </Button>
        <Button variant="outlined" color="warning">
          Xuất PDF
        </Button>
        <Button variant="outlined" color="primary" disabled>
          Xuất PDF
        </Button>
      </Box>
      <Box display="flex" gap={1}>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          color="primary"
        >
          Xuất PDF
        </Button>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          color="success"
        >
          Xuất PDF
        </Button>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          color="error"
        >
          Xuất PDF
        </Button>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          color="warning"
        >
          Xuất PDF
        </Button>
        <Button
          startIcon={<CloudUploadIcon />}
          variant="contained"
          color="primary"
          disabled
        >
          Xuất PDF
        </Button>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Box>
          {" "}
          <Button variant="contained" color="success" size="small">
            Xuất PDF
          </Button>
        </Box>
        <Box>
          {" "}
          <Button variant="text" color="success" size="medium">
            Xuất PDF
          </Button>
        </Box>
        <Button variant="outlined" color="success" size="large">
          Xuất PDF
        </Button>
        <Button>Default không truyền gì</Button>
      </Box>
    </Box>
  );
};

export default ButtonView;
